// import { gsap } from 'gsap';

let projectEllipseTL, projectImgTL, projectImgSecondTL;

window.projectGradientGSAPAnimation = function () {
  const imgContainer = document.querySelector('.project-bg__bg-decor-ellipses');
  const main = document.querySelector('.main');

  if (!imgContainer || !main) return;

  imgContainer.getBoundingClientRect();

  requestAnimationFrame(() => {
    const img = imgContainer.querySelector(
      '.project-bg__bg-decor-ellipse-img:nth-child(1)'
    );
    const imgSecond = imgContainer.querySelector(
      '.project-bg__bg-decor-ellipse-img:nth-child(2)'
    );

    gsap.set(imgContainer, {
      xPercent: 0,
      yPercent: -50,
      x: 0,
      y: 0,
      transformOrigin: 'right bottom',
    });

    projectEllipseTL = gsap.to(imgContainer, {
      rotation: 360,
      ease: 'none',
      repeat: -1,
      duration: 30,
    });

    projectImgTL = gsap.to(img, {
      rotation: -360,
      ease: 'none',
      repeat: -1,
      duration: 30,
    });

    projectImgSecondTL = gsap.to(imgSecond, {
      rotation: 360,
      ease: 'none',
      repeat: -1,
      duration: 40,
    });
  });
};

window.pauseProjectGradientAnimation =
  function pauseProjectGradientAnimation() {
    projectEllipseTL?.pause();
    projectImgTL?.pause();
    projectImgSecondTL?.pause();
  };

window.resumeProjectGradientAnimation =
  function resumeProjectGradientAnimation() {
    if (window.innerWidth > 1024) {
      projectEllipseTL?.play();
      projectImgTL?.play();
      projectImgSecondTL?.play();

      /*console.log(
        projectEllipseTL?.paused(),
        projectImgTL?.paused(),
        projectImgSecondTL?.paused()
      );*/
    }
  };

projectGradientGSAPAnimation();

if (!document.querySelector('.bold-loader-new')) {
  pauseProjectGradientAnimation();
}

if (window.innerWidth < 1025) {
  setTimeout(function () {
    pauseProjectGradientAnimation();
  }, 100);
}
